import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Product } from '../../../libs/proto/shop_pb';

@Injectable({
  providedIn: 'root'
})
export class ProductConversionService {

  constructor() { }

  ToStorage(req: Product) {
    const w = new BinaryWriter();
    Product.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (news: Product, errorConvert: any) => void) {
    try {
      callback( Product.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(news: Product[]) {
    const rets = new Array<Uint8Array | number[]>();

    news.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (news: Product[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Product>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Product.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
